import { definePlugin } from 'villus';

/**
 * Sets the authorization header for all requests.
 */
const authPlugin = (token) => {
    return definePlugin(({ opContext }) => {
        opContext.headers.Authorization = `Bearer ${token}`;
    });
};

export default authPlugin;
